import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFormControls, BaasicFieldDropdown, BaasicButton } from 'core/components';

function EditFacilityOrderTemplateInactiveReasonModalTemplate({ editFacilityOrderTemplateInactiveReasonModalStore , t}) {
    const {
        form,
        inactiveReasonStore,
        modalParams
    } = editFacilityOrderTemplateInactiveReasonModalStore;

    return (
        <section className='w--400--px'>
            <div className="modal__header">
                <h4 className='modal__header__title'>Edit Inactive Reason</h4>
            </div>

            <div className="modal__body">
                <div className="form__group">
                    <BaasicFieldDropdown field={form.$('inactiveReasonId')} store={inactiveReasonStore} />
                </div>
            </div>

            <div className='modal__footer'>
                <BaasicFormControls
                    form={form} 
                    onSubmit={form.onSubmit} 
                    disabled={form.submitting || form.validating} 
                    className='btn btn--med btn--primary'
                    label="Save"
                />
                <BaasicButton
                     className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                />
            </div>
        </section> 
    )
}
 
EditFacilityOrderTemplateInactiveReasonModalTemplate.propTypes = {
    editFacilityOrderTemplateInactiveReasonModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(EditFacilityOrderTemplateInactiveReasonModalTemplate);
